import mapdark_icon from '@images/map-icons/mapbox-dark.png'
import defaultmap_icon from '@images/map-icons/google-roadmap.png'
import mapsatellite_icon from '@images/map-icons/google-satellite.png'
import mapnavigation_icon from '@images/map-icons/mapbox-navigation.png'
import topo_icon from '@images/map-icons/mapbox-whiteblack.png'

const layer_helper = {
    layerTileByName(name){

        if(name === 'default'){
            return {
                name:'default',
                icon: defaultmap_icon,
                layer:L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }),
                title: 'Mapa'
            }
        } else if(name === 'dark'){
            return {
                name:'dark',
                icon: mapdark_icon, 
                layer: L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png'), 
                title: 'Escuro'
            }
        } else if(name === 'satellite'){
            return {
                name:'satellite',
                icon:mapsatellite_icon,
                layer:L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
                    attribution: 'Tiles &copy; Esri'
                }),
                title: 'Satélite'
            }
        } else if(name === 'navigation'){
            return {
                name:'navigation',
                icon:mapnavigation_icon,
                layer:L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/navigation-day-v1/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGllZ29mcmVpdGFzIiwiYSI6ImNsbmk3b3duZTBreDcya21qNWRhMHdtN3EifQ.egznqPLgPUhUXHPMKywOoQ', {
                }),
                title: 'Navegação'
            }
        } else if(name === 'hidro'){
            return {
                name:'hidro',
                icon:mapnavigation_icon,
                layer:L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}', {
                }),
                title: 'Hidro'
            }
        } else if(name === 'topo'){
            return {
                name:'topografia',
                icon:topo_icon,
                layer:L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
                    attribution: 'Tiles &copy; Esri &mdash; Sources: Esri, USGS, NOAA'
                }),
                title: 'Topografia'
            }
        }
    }
}

export default layer_helper